import { createBrowserRouter } from "react-router-dom";

import CheckoutContextProvider from "@/providers/context/CheckoutContext";

import AgeGroupPage from "@react-pages/Checkout/AgeGroupPage";
import CheckoutPage from "@react-pages/Checkout/CheckoutPage";
import CreateNewStudentPage from "@react-pages/Checkout/CreateNewStudentPage";
import ExistingUserPage from "@react-pages/Checkout/ExistingUserPage";
import GradeCurriculumPage from "@react-pages/Checkout/GradeCurriculumPage";
import InternationalPremiumServicesPage from "@react-pages/Checkout/InternationalPremiumServicesPage";
import MembershipPage from "@react-pages/Checkout/MembershipPage";
import PathwayPage from "@react-pages/Checkout/PathwayPage";
import PaymentSuccessPage from "@react-pages/Checkout/PaymentSuccessPage";
import PremiumServicesPage from "@react-pages/Checkout/PremiumServicesPage";
import StatePage from "@react-pages/Checkout/StatePage";
import StudentSelectionPage from "@react-pages/Checkout/StudentSelectionPage";
import UserInfoPage from "@react-pages/Checkout/UserInfoPage";

import NotFoundPage from "@error-pages/NotFoundPage";

import CheckoutLayout from "@layouts/CheckoutLayout.tsx";

const checkoutRouter = createBrowserRouter([
    {
        path: "/checkout",
        // Checkout context is only available within checkout portal
        element: (
            <CheckoutContextProvider>
                <CheckoutLayout />
            </CheckoutContextProvider>
        ),
        children: [
            {
                path: "*",
                element: <NotFoundPage />
            },
            {
                index: true,
                element: <UserInfoPage />
            },
            {
                path: "select-state",
                element: <StatePage />
            },
            {
                path: "select-student",
                element: <StudentSelectionPage />
            },
            {
                path: "create-new-student",
                element: <CreateNewStudentPage />
            },
            {
                path: "select-age-group",
                element: <AgeGroupPage />
            },
            {
                path: "grade-curriculum",
                element: <GradeCurriculumPage />
            },
            {
                path: "select-membership",
                element: <MembershipPage />
            },
            {
                path: "select-pathway",
                element: <PathwayPage />
            },
            {
                path: "select-premium-services",
                element: <PremiumServicesPage />
            },
            {
                path: "international-premium-services",
                element: <InternationalPremiumServicesPage />
            },
            {
                path: "payment",
                element: <CheckoutPage />
            },
            {
                path: "payment-success",
                element: <PaymentSuccessPage />
            },
            {
                path: "existing-user",
                element: <ExistingUserPage />
            }
        ]
    }
]);

export default checkoutRouter;
